<template>
  <section class="flight">
    <flight-status :status="flight.status" class="flight__status"/>
    <div class="flight__info">
      <div class="flight__info-truck">
        <div v-if="truckAdded" class="picture added flex-center">
          <img src="@/assets/img/new-truck-green.svg" class="picture__icon" alt="truck">
        </div>
        <div v-else class="picture absent flex-center">
          <img src="@/assets/img/new-truck-gray.svg" class="picture__icon" alt="truck">
        </div>
        <div class="flex-column-between">
          <div class="font-title">
            {{ truckNumber }}
          </div>
          <div class="flex-v-center">
            <img src="@/assets/img/new-calendar.svg" class="date" alt="date">
            <div class="font-date"> {{ formattedDate }} </div>
          </div>
        </div>
      </div>
      <div v-if="flight.type_code === 'harvest_or_delivery'" class="flex-column-between">
        <div class="font-price">
          <span>{{ flightDeliveryPrice }}&nbsp;₽/кг</span>
          <span class="mod-type">(П)</span>
        </div>
        <div class="font-price">
          <span>{{ flightHarvestPrice }}&nbsp;₽/кг</span>
          <span class="mod-type">(У)</span>
        </div>
      </div>
      <div v-else class="single-price">
        <div class="font-small single-price__title">{{ flightType }}</div>
        <div class="font-price">{{ flightPrice }}&nbsp;₽/кг</div>
      </div>
    </div>
    <div class="flight__routes flex-between-center">
      <div class="flight__routes-text">
        <div class="point flex">
          <div class="arrow" />
          <div class="font-small">{{ loadAddress }}</div>
        </div>
        <div class="point flex">
          <div class="circle" />
          <div class="font-small">{{ unloadAddress }}</div>
        </div>
      </div>
      <div class="flight__routes-more flex-center" @click="goToFlight">
        <img src="@/assets/img/new-angle-right.svg" class="more__icon" alt="more">
      </div>
    </div>
  </section>
</template>

<script>
import FlightStatus from './FlightStatus'
import FlightsMixin from '../FlightsMixin'
export default {
  name: 'Flight',
  components: { FlightStatus },
  mixins: [ FlightsMixin ],
  props: {
    flight: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // не используется в случае Перевозка+уборка, поэтому два варианта
    flightType() {
      return this.flight.type_code === 'delivery' ? 'Перевозка' : 'Уборка'
    },
  },
  methods: {
    goToFlight() {
      this.$router.push({ name: 'FlightMobile', params: { id: this.flight.item_id, type: this.flight.item_type } })
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.flight
  position: relative
  margin-bottom: 3rem
  padding: 1.6rem
  background: #FFFFFF
  box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15)
  border-radius: 1.2rem

  &__status
    position: absolute
    top: -1.4rem
    left: .7rem
  &__info
    display: flex
    justify-content: space-between
    padding-bottom: 1.2rem
    border-bottom: 1px solid #EFEFEF
    &-truck
      display: flex
      .picture
        width: 4.4rem
        height: 4.4rem
        margin-right: 1.2rem
        border-radius: .8rem
        &.added
          background: #EBF9EB
        &.absent
          background: #EDEDED
        &__icon
          width: 2.4rem
          height: 2.4rem
      .date
        width: 1.6rem
        height: 1.6rem
        margin-right: 0.2rem
  &__routes
    margin-top: .8rem

    &-text
      margin-right: 5rem
      .point:first-child
        margin-bottom: .4rem

    .arrow
      flex-shrink: 0
      width: 1.6rem
      height: 1.6rem
      margin-right: 0.4rem
      background: url('~@/assets/img/new-bid-arrow.svg')
      background-size: cover
    .circle
      flex-shrink: 0
      width: 1.6rem
      height: 1.6rem
      margin-right: 0.4rem
      background: url('~@/assets/img/new-circle.svg')
      background-size: cover
    &-more
      flex-shrink: 0
      width: 3.4rem
      height: 3.4rem
      margin-top: 0.2rem
      border-radius: .8rem
      background: #EDEDED
      cursor: pointer
      .more__icon
        width: 1.8rem
        height: 1.8rem

.single-price
  text-align: end
  &__title
    margin-bottom: .4rem

.font-title
  font-weight: 700
  font-size: 1.6rem
  line-height: 2rem
  color: #181818
.font-small
  font-weight: 400
  font-size: 1.2rem
  line-height: 1.6rem
  color: #5C5C5C
.font-price
  text-align: right
  font-weight: 700
  font-size: 1.6rem
  line-height: 2rem
  color: $mainColor
  .mod-type
    margin-left: 0.3rem
    font-weight: 400
    color: #5C5C5C
.font-date
  font-weight: 700
  font-size: 1.4rem
  line-height: 1.8rem
  color: #747474

</style>
